import styled from 'styled-components';
import { colors } from '@prisjakt/ui-base';
import TooltipComponent from '@prisjakt/ui-tooltip-new';

const Tooltip = styled(TooltipComponent)``;

const CompareProductButton = styled.button`
  align-self: stretch;
  outline: none;
  cursor: pointer;
  padding: 0 8px;
  min-height: 43px;
  position: relative;
  fill: ${props => (props.active ? colors.darkBlue1 : colors.mediumGray1)};
  background-color: ${props => (props.active ? colors.yellow3 : 'transparent')};
  svg {
    margin-top: -1px;
  }

  :hover {
    svg g,
    svg path {
      fill: ${props => (props.active ? colors.darkBlue1 : colors.green2)};
    }
  }

  ${Tooltip} {
    transition: visibility 0s 0.1s, opacity 0.1s linear;
    visibility: hidden;
    opacity: 0;
    z-index: 9999;
  }

  :hover ${Tooltip} {
    transition: visibility 0s, opacity 0.2s linear;
    visibility: visible;
    opacity: 1;
  }
`;

export { Tooltip, CompareProductButton };
